import React from 'react';
import PropTypes from 'prop-types';

import lineBreak from 'utils/lineBreak';

const SummaryAndBioSection = ({ training, showBio }) => {
  return (
    <div className="training-schedule-block">
      <h2 className="medium-heading black-txt" style={{ maxWidth: 1100 }}>
        {training.description}
      </h2>

      <div
        className={
          showBio ? 'training-summary' : 'training-summart-without-bio'
        }
      >
        <div>
          <h3>Summary</h3>
          <p className="summary-section">{training.summary}</p>
        </div>
        {showBio ? (
          <div>
            <h3>Trainer Bio</h3>
            <p
              dangerouslySetInnerHTML={{ __html: lineBreak(training.bio) }}
            ></p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

SummaryAndBioSection.propTypes = {
  training: PropTypes.object,
  showBio: PropTypes.bool,
};

export default SummaryAndBioSection;
